export default "__VITE_ASSET__D1H_RVXX__"